import client from './client'
import { fetchCsrfCookie } from '@/api/auth'
import type { ContactMessagePayload } from '@/types/contact'

// Public endpoint, answers 204 without a body. The CSRF cookie is fetched first
// because the SPA is a stateful (Sanctum) client and the API answers 419 without it.
export async function submitContactMessage(payload: ContactMessagePayload): Promise<void> {
  await fetchCsrfCookie()
  await client.post('/public/contact-messages', payload)
}
